<template>
  <Button
    size="icon"
    variant="ghost"
    type="button"
    aria-label="Edit file"
    @click="edit(index)"
  >
    <slot>
      <Pencil />
    </slot>
  </Button>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue'
import { Pencil } from 'lucide-vue-next'
import { Button } from "@/components/ui/button";

export default defineComponent({
  components: {
    Pencil, Button
  },
  props: {
    index: {
      type: [String, Number],
      default: ''
    }
  },
  setup() {
    return {
      edit: inject<(index: string | number) => void>('edit', () => {})
    }
  }
})
</script>
